<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Aktivitätsdetails"
    iconPath="assets/icons/calendar-dots-light.svg"
  />

  <div class="p-6 flex flex-col gap-6 mb-20">
    <div class="flex flex-col justify-center items-start">
      <span class="font-medium">Typ</span>
      <span>{{ activityTypeLabel() }}</span>
    </div>

    <div class="flex flex-col justify-center items-start">
      <span class="font-medium">Datum</span>
      <span>{{ data.activity.scheduledDate | dayjsFormat: 'date' }}</span>
    </div>

    <div class="flex flex-col justify-center items-start">
      <span class="font-medium">Titel</span>
      <span>{{ title() }}</span>
    </div>

    <div class="flex flex-col justify-center items-start">
      <span class="font-medium">Beschreibung</span>
      <span>{{ description() }}</span>
    </div>
  </div>
</div>
